module.exports = __webpack_public_path__ + "img/SKMJ_heavy12.60a309b0.jpg";